<template>
  <div class="card border-0 bg-white profile-settings-card rounded-0">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <h4 class="fw-bold">
        {{ $t('page.invitation_form') }}
      </h4>
      <form v-on:submit="submit">
        <div class="row">

          <!-- INSTRUCTIONS -->

          <div class="col-12">
            <p class="mb-15 mb-sm-20 text-black">{{ $t('form.invite_user_instructions') }}</p>
          </div>





          <!-- ANAGRAPH -->
          <div class="col-12">
            <h4 class="mb-15 mb-sm-20 mb-md-25">{{ $t('form.section.user_information') }}</h4>
          </div>


          <!-- FIRST NAME -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.first_name.label') }}*
              </label>
              <input v-model="user.firstname" type="text" class="form-control shadow-none text-black"
                :required="!is_patient" :placeholder="$t('form.first_name.placeholder')"
                :class="[{ 'is-invalid': submitted && errors?.firstname }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.firstname ?? false">
                <p v-for="error in errors.firstname" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- LAST NAME -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.last_name.label') }}*
              </label>
              <input v-model="user.lastname" type="text" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.lastname }]" :required="!is_patient"
                :placeholder="$t('form.last_name.placeholder')" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.lastname ?? false">
                <p v-for="error in errors.lastname" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <div class="col-12"></div>

          <!-- ROLE_IN_DEPARTMENT 
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.role_in_department.label') }}
              </label>
              <input v-model="user.role_in_department" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.role_id }]" />
               ERRORS 
              <div class="form-messages mt-2 px-1" v-if="errors?.role_in_department ?? false">
                <p v-for="error in errors.role_in_department" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div> -->

          <!-- CONTACTS -->
          <div class="col-12">
            <h4 class="mb-15 mb-sm-20 mb-md-25">{{ $t('form.section.contacts') }}</h4>
          </div>
          <!-- CREATE -->
          <!-- EMAIL -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.email.label') }}*
              </label>
              <input v-model="user.email" type="email" class="form-control shadow-none text-black" required disabled
                pattern="[^@\s]+@[^@\s]+\.[^@\s]+" :class="[{ 'is-invalid': submitted && errors?.email }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.email ?? false">
                <p v-for="error in errors.email" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- PHONE -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.phone.label') }}
              </label>
              <input v-model="user.phone_number" type="text" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.phone_number }]"
                :placeholder="$t('form.phone.placeholder')" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.phone_number ?? false">
                <p v-for="error in errors.phone_number" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
        </div>
        <template v-if="env === 'sifi_fk' || env === 'fungalk'">
          <!-- CHECKBOXES -->
          <div class="col-12">
            <div class="form-check form-group mb-15 mb-sm-20 mb-md-25">
              <input class="form-check-input shadow-none" type="checkbox" v-model="terms_of_use_accepted"
                id="terms_of_use" :required="true">
              <label class="form-check-label fw-medium position-relative top-1" for="terms_of_use" v-html="$t('invitation_policies.terms_of_use', {url: $t(`footer_links.terms_of_use.${env}`)})"></label>
            </div>
          </div>
          <div class="col-12">
            <div class="form-check form-group mb-15 mb-sm-20 mb-md-25">
              <label class="form-check-label fw-medium position-relative top-1" v-html="$t('invitation_policies.privacy_policy', {url: $t(`footer_links.privacy_policy.${env}`)})"></label>
            </div>
          </div>
          <div class="col-12">
            <div class="form-check form-group mb-15 mb-sm-20 mb-md-25">
              <label class="form-check-label fw-medium position-relative top-1" v-html="$t('invitation_policies.cookie_policy', {url: $t(`footer_links.cookie_policy.${env}`)})"></label>
            </div>
          </div>
        </template>

        <div class="col-12" v-if="loading">
          <SpinnerLoading />
        </div>
        <div class="col-md-12" v-else>
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <!-- SAVE -->
            <div class="d-flex flex-wrap gap-3 justify-content-end ms-auto">
              <DiscardButton @confirm="$router.push({
                path: '/login'
              })" />
              <button
                class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                type="submit" v-on:click="submitted = true">
                {{ $t('cta.accept_invitation') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- ERROR MESSAGE -->
  <div class="row justify-content-center">
    <div class="col">
      <div
        class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25"
        role="alert" id="errorMessage">
        <strong>{{ $t('error.something_went_wrong') }}</strong>
        <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
      </div>
    </div>
  </div>

  <AlertModal id="alertModal" :title="$t('error.something_went_wrong')" :message="error_message" @confirm="redirect"
    :dismissible="false" />
  <AlertModal id="successModal" :title="$t('feature.auth.invitation')"
    :message="$t('feature.auth.$invitation.accept_success_message')" @confirm="redirect" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DiscardButton from "@/components/Widgets/DiscardButton.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { CreateUserInfo, Role, RoleInfo, UserInfo } from "@/utils/models/user.model";
import { removeNullProperties } from "@/utils/methods/remove_null_properties";
import API from "@/services/api/api.service";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import { Modal } from "bootstrap";
import LangStorage from "@/utils/methods/lang_storage";
import stateStore from "@/utils/store";
import config, { Environment } from "@/utils/const/config";
import { CLIENT } from '@/utils/const/env';
import { defaultLanguage } from "@/assets/i18n/i18n";

export default defineComponent({
  name: "InvitationForm",
  components: {
    SpinnerLoading,
    DiscardButton,
    AlertModal,
  },
  data: function () {
    return {
      user: {
        role_id: this.$route.query?.role_id !== undefined ? parseInt(this.$route.query?.role_id as string) : undefined
      } as CreateUserInfo,
      submitted: false,
      roles: ((this.$route.meta.roles as RoleInfo[]) ?? []).filter((role) => role.type != Role.patient && role.type != Role.caregiver) ?? [] as RoleInfo[],
      loading: false,
      errors: undefined as any,
      center_id: this.$route.query?.center_id as string | undefined,
      token: this.$route?.params.token as string | undefined,
      successModal: null as Modal | null,
      alertModal: null as Modal | null,
      error_message: undefined as string | undefined,
      lang: this.$route.query?.lang as string | undefined,

      terms_of_use_accepted: false,
    }
  },
  mounted() {
    console.log(this.lang)
    this.changeLocale(this.lang);
    this.alertModal = new Modal('#alertModal', {});
    this.successModal = new Modal('#successModal', {});
    if (this.token === undefined || this.token === null || this.token === '') {
      this.alertModal?.show();
      return;
    }
    API.getInviteToken({ token: this.token ?? '' }).then((response) => {
      this.user.email = response.data.data.email;
    }).catch((error) => {
      console.log('ERROR', error);
      this.error_message = error?.data?.message ?? this.$t('error.something_went_wrong');
      this.alertModal?.show();
    });
    var userInfo = this.$route.meta.user as UserInfo | undefined;
    if (userInfo != undefined) {
      this.user = {
        id: userInfo.id,
        email: userInfo.email,
        firstname: userInfo.firstname,
        lastname: userInfo.lastname,
        phone_number: userInfo.phone_number,
        role_id: userInfo.role.id,
        role_in_department: userInfo.role_in_department != '' ? userInfo.role_in_department : undefined,
      }
    }
  },
  computed: {
    role_id_param(): number | undefined { return this.$route.query?.role_id !== undefined ? parseInt(this.$route.query?.role_id as string) : undefined; },
    update() {
      return this.$route.meta.user !== undefined && this.$route.meta.user !== null;
    },
    role_info(): RoleInfo | undefined {
      return this.roles?.find((role) => role.id == this.user.role_id);
    },
    is_patient(): boolean {
      return this.role_info?.type == Role.patient;
    },
    is_caregiver(): boolean {
      return this.role_info?.type == Role.caregiver;
    },
    is_admin(): boolean {
      return this.role_info?.type == Role.admin;
    },
    is_hcp(): boolean {
      return this.role_info?.type == Role.hcp || this.role_info?.type == Role.internal;
    },
    env(): Environment { return CLIENT },
  },
  methods: {
    changeLocale(locale: string | undefined) {
      let lang_exists = config.available_locales.includes(locale ?? '');
      this.$i18n.locale = lang_exists ? (locale ?? defaultLanguage()) : defaultLanguage();
      LangStorage.set(this.$i18n.locale);
    },
    submit(event): void {
      this.errors = undefined;
      event.preventDefault();

      if (this.is_patient) {
        this.user.firstname = undefined;
        this.user.lastname = undefined;
      }
      removeNullProperties<UserInfo>(this.user);

      this.loading = true;


      console.log('CREATE');

      API.acceptInvite({ token: this.token!, invited_user: this.user, terms_of_use_accepted: this.terms_of_use_accepted }).then((response) => {
        if (response.data.success === true) {
          this.errors = undefined;
          this.successModal?.show();
        } else {
          this.errors = response.data.errors;
          this.showError();
          return;
        }

      }).catch((error) => {
        this.errors = error.response?.data?.errors;
        this.showError();
      }).finally(() => {
        this.loading = false;
      });
    },
    showError() {
      const error = document.getElementById('errorMessage');
      error?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    },
    redirect() {
      this.$router.push('/login');
    },
  },
});
</script>